import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-tag',
	templateUrl:'./WaTagPluginCompPage.html',
	styles: [],
	styleUrls:['./WaTagPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaTagPluginCompPage
{
	mdContent_1148 = `\`\`\`java
import com.jwebmp.webawesome.components.tag.WaTag;
\`\`\``;
	mdContent_1149 = `\`\`\`java
new WaTag&lt;&gt;()
\`\`\``;
}
